exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divider[data-v-094cd1f6]{height:10px;background-color:#EBEEF5}.titleWidget[data-v-094cd1f6]{padding:0 16px}.title[data-v-094cd1f6]{font-weight:bold;font-size:24px;padding-top:8px !important}\n", ""]);

// exports
